import Home from 'pages/blog/page';

const FootballBlogPage = () => <Home sportCategory="football" />;
export default FootballBlogPage;
